// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--tFeG9","name":"header-module--name--nOZGB","customMedia":{},"customProperties":{},"customSelectors":{}};